<template>
  <div
    :class="
      active ? 'bottom-card active-card py-7 px-7' : 'bottom-card py-7 px-7'
    "
  >
    <v-row class="mx-5">
      <v-col cols="12" class="d-flex justify-space-between text" v-if="active">
        <p class="white--text">
          <strong>{{ active }} Faturas selecionadas</strong>
        </p>
        <p
          class="white--text"
          @click="$emit('deselect')"
          @click.right="$emit('deselect')"
        >
          <img src="@/assets/ic-deselect-all.png" alt="" width="20" />
          <strong> Limpar seleção</strong>
        </p>
      </v-col>

      <v-col cols="12" class="text-center text" v-else>
        <strong>
          <v-icon color="grey lighten-2" size="24"
            >mdi-checkbox-marked-circle-outline</v-icon
          >
          <span class="pl-2 pt-7">Selecione as faturas</span>
        </strong>
      </v-col>

      <v-col cols="6">
        <v-btn
          block
          rounded
          :disabled="!active"
          @click="handlePrintInvoiceDialog"
          @click.right="handlePrintInvoiceDialog"
          :class="active ? 'py-8 active-btn' : 'button py-8'"
        >
          <img src="@/assets/ic-payment-barcode.png" class="pr-10" alt="" />
          Imprimir <br />
          boleto
        </v-btn>
      </v-col>

      <v-col cols="6">
        <v-btn
          block
          rounded
          :disabled="!active"
          @click="handlePaymentCardDialog"
          @click.right="handlePaymentCardDialog"
          :class="active ? 'py-8 active-btn' : 'py-8 button py-8'"
        >
          <img src="@/assets/ic-payment-card.png" class="pr-10" alt="" /> Pagar
          com <br />
          cartão
        </v-btn>
      </v-col>

      <v-col cols="6">
        <v-btn
          block
          rounded
          :disabled="!active"
          @click="handleEmailDialog"
          @click.right="handleEmailDialog"
          :class="active ? 'py-8 active-btn' : 'button py-8'"
        >
          <v-icon left light size="35" class="pr-4">mdi-email-outline</v-icon>
          <span>Enviar por e-mail</span>
        </v-btn>
      </v-col>

      <v-col cols="6">
        <v-btn
          block
          rounded
          :disabled="!active"
          @click="handleSmsDialog"
          @click.right="handleSmsDialog"
          :class="active ? 'py-8 active-btn' : 'button py-8'"
        >
          <v-icon left light size="35" class="pr-4"
            >mdi-cellphone-message</v-icon
          >
          <span>Enviar por sms</span>
        </v-btn>
      </v-col>
    </v-row>

    <PrintInvoiceDialog
      v-if="openPrintInvoiceDialog"
      :openDialog="openPrintInvoiceDialog"
      @close="openPrintInvoiceDialog = !openPrintInvoiceDialog"
    />

    <PaymentDialog 
      v-if="openPaymentDialog"
      :openDialog="openPaymentDialog" 
      @close="openPaymentDialog = !openPaymentDialog"
      @handleIsSendingReceipt="handleIsSendingReceipt" 
    />

    <EmailDialog
      v-if="openEmailDialog"
      :openDialog="openEmailDialog"
      @close="openEmailDialog = !openEmailDialog"
      :isSendingReceipt="isSendingReceipt"
      :receipt="receipt"
    />

    <SmsDialog
      v-if="openSmsDialog"
      :openDialog="openSmsDialog"
      @close="openSmsDialog = !openSmsDialog"
    />
  </div>
</template>

<script>
import PaymentDialog from "@/components/PaymentDialog";
import EmailDialog from "@/components/EmailDialog";
import SmsDialog from "@/components/SmsDialog";
import PrintInvoiceDialog from "@/components/PrintInvoiceDialog";
export default {
  name: "BottomCard",
  components: {
    PaymentDialog,
    EmailDialog,
    SmsDialog,
    PrintInvoiceDialog,
  },
  props: {
    active: {
      type: Number,
      default: 0,
    },
    handleEmailSending: {
      type: Function,
      default: (response) => response,
    },
    handleSMSSending: {
      type: Function,
      default: (response) => response,
    },
    handlePrintInvoice: {
      type: Function,
      default: (response) => response,
    },
    handlePaymentCard: {
      type: Function,
      default: (response) => response,
    },
    invoices: {
      type: Array,
    },
  },
  data() {
    return {
      openDialog: false,
      openEmailDialog: false,
      openSmsDialog: false,
      openPrintInvoiceDialog: false,
      openPaymentDialog: false,
      isSendingReceipt: false,
      receipt: {}
    };
  },
  methods: {
    handleEmailDialog() {
      this.isSendingReceipt = false;
      this.handleEmailSending();
      this.openEmailDialog = !this.openEmailDialog;
    },
    handleSmsDialog() {
      this.handleSMSSending();
      this.openSmsDialog = !this.openSmsDialog;
    },
    handlePrintInvoiceDialog() {
      this.handlePrintInvoice();
      this.openPrintInvoiceDialog = !this.openPrintInvoiceDialog;
    },
    handlePaymentCardDialog() {
      this.handlePaymentCard();
      this.openPaymentDialog = !this.openPaymentDialog;
    },
    handleIsSendingReceipt(receipt) {
      this.isSendingReceipt = true;
      this.openEmailDialog = !this.openEmailDialog;
      this.receipt = receipt;
    }
  },
};
</script>

<style scoped>
.bottom-card {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(22, 33, 45, 0.8);
  box-shadow: 0px 6px 0px rgba(255, 255, 255, 0.4),
    0px 0px 32px rgba(35, 41, 46, 0.2);
  backdrop-filter: blur(24px);
  border-radius: 32px 32px 0px 0px;
}

.active-card {
  background-image: url('../assets/background.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* background: rgba(12, 204, 166, 0.6); */
}

.bottom-card .text {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.65);
}

.bottom-card button {
  font-size: 17px !important;
  background: rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0px 4px 0px rgba(255, 255, 255, 0.5),
    0px 6px 16px rgba(35, 41, 46, 0.5) !important;
}

.bottom-card button.active-btn {
  font-size: 17px !important;
  background: rgba(255, 255, 255, 0.87) !important;
  box-shadow: 0px 4px 0px rgba(255, 255, 255, 0.4),
    0px 6px 16px rgba(35, 41, 46, 0.2) !important;
}
.img-email {
  width: 40px;
  background-size: cover;
}
</style>